import IndexModel from "@/service/v10/sigap/IndexModel";
 
class NotaService extends IndexModel { 
       
    constructor() {
        super();
        this.url =  this.url + '/Nota' ;  
    }
 
    public getApiUrl(  ) { 
        return this.getAxios().defaults.baseURL + this.url; 
    }
 
    public getModel( id  ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/' + id )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getTipo(    ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url + '/GetTipo')
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
    
    public getStatus( ) : Promise<any> { 
        return  new Promise((resolve, reject) => {
            this.getAxios().get( this.url  + '/GetStatus'   , {}  )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {  
                reject(error.response);
            }) 
        }); 
    }
     
    public homologarNotaProfile( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url + '/' + id + '/Homologar' )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
    public solicitarRevisaoProfile( id: any ) : Promise<any> { 
        return  new Promise((resolve, reject) => {  
            this.getAxios().put( this.url   + '/' + id + '/Revisar' , {}   )
            .then(response => {    
                resolve( response.data);  
            })
            .catch(error => {   
                reject(error.response);
            }) 
        }); 
    }
 
}
  
export default NotaService; 